export enum UserLocalStorageKeys {
    FlightSearchRecentlySearchedOriginStations = 'flightSearch.recentlySearchedOriginStations',
    FlightSearchRecentlySearchedDestinationStations = 'flightSearch.recentlySearchedDestinationStations',
    BookingMyTrips = 'booking.myTrips',
    BookingBoardingPasses = 'booking.boardingPasses',
    BookingInvoice = 'booking.invoice',
    BookingCardInfo = 'booking.cardInfo',
    UserProfileBookingContact = 'userProfile.bookingContact',
    AuthorizedUserMyTrips = 'authorizedUser.myTrips',
    AuthorizedUserMyBoardingPasses = 'authorizedUser.myBoardingPasses',
    AuthorizedUserAttachedBookings = 'authorizedUser.attachedBookings',
    BookingsSearchCurrentViewMode = 'bookingsSearch.currentViewMode',
    BookingsSearchFiltersCurrentFilter = 'bookingsSearch.filters.currentFilter',
}